/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NotariatsgeschaeftDTO { 
    id?: string;
    document?: string;
    nummer?: string;
    improvedDocuments?: Array<string>;
    egbtbid?: string;
}

